export default __webpack_public_path__ + "static/13_31-aa5e93e324e10f937f19d30ae8a2089e.png";